import React, { Fragment } from "react";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { notificationValidations } from "./notificationConstant";
import FormInput from "../Common/FormInputs/MuiTextField";
import { SectionHeading, LabelText, ValueText } from "../Common/Typography/AppTypography";

const fieldRowSx = {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", md: "200px minmax(0, 500px)" },
    alignItems: "center",
    gap: 1.5,
    marginBottom: 2,
    "&:last-of-type": { marginBottom: 0 },
};
const sectionCardSx = {
    p: 2,
    mt: 1.5,
    boxShadow: 2,
    borderRadius: 1,
};

const SMSNotification = ({
    handleMessageData,
    messageData
}) => {
    return (
        <Fragment>
            <SectionHeading sx={{ mt: 2 }}>Message</SectionHeading>
            <Paper sx={sectionCardSx}>
                <Box sx={fieldRowSx}>
                    <LabelText strong>Message:</LabelText>
                    <Box sx={{ maxWidth: 500 }}>
                        <FormInput
                            type="textarea"
                            rows={4}
                            placeholder="Write a Message"
                            value={messageData}
                            onChange={(e) => {
                                handleMessageData((e.target.value).substring(0, notificationValidations?.sms?.body?.maxLength))
                            }}
                            sx={{ maxWidth: 500 }}
                        />
                        <ValueText sx={{ display: "block", mt: 0.5, fontSize: "0.75rem" }}>
                          {(messageData?.length > notificationValidations?.sms?.body?.maxLength
                            ? notificationValidations?.sms?.body?.maxLength
                            : messageData?.length) + "/" + notificationValidations?.sms?.body?.maxLength}
                        </ValueText>
                    </Box>
                </Box>
            </Paper>
        </Fragment>
    );
}


export default SMSNotification